import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ebc5214"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://gitee.com/lyt-top/vue-next-admin-images/raw/master/logo/logo-mini.svg",
  class: "layout-logo-medium-img"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://gitee.com/lyt-top/vue-next-admin-images/raw/master/logo/logo-mini.svg",
  class: "layout-logo-size-img"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.setShowLogo)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "layout-logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onThemeConfigChange && $setup.onThemeConfigChange(...args)))
      }, [
        _hoisted_1,
        _createElementVNode("span", null, _toDisplayString($setup.getThemeConfig.globalTitle), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "layout-logo-size",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onThemeConfigChange && $setup.onThemeConfigChange(...args)))
      }, _hoisted_3))
}